import PersonalInfo from './PersonalInfo'
export const Home: IRoute[] = [
	{
		path: '/',
		component: PersonalInfo,
	},
]



// WEBPACK FOOTER //
// ./src/modules/Home/index.ts